/*hit-your-first-turborepo-cache*/
/*create-a-new-turborepo-project*/
/*run-a-build-for-the-first-time*/
/*hit-the-cache*/
/*remote-caching*/
/*enabling-remote-cache*/
/*what-gets-cached*/
/*task-outputs*/
/*logs*/
/*task-inputs*/
/*global-hash-inputs*/
/*package-hash-inputs*/
/*troubleshooting*/
/*using-dry-runs*/
/*using-run-summaries*/
/*turning-off-caching*/
/*overwriting-a-cache*/
/*caching-a-task-is-slower-than-executing-the-task*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "缓存",
  "description": "了解 Turborepo 中的缓存。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 使用缓存来加速构建，确保你不会重复执行相同的工作。当你的任务可缓存时，Turborepo 将使用任务首次运行时的指纹从缓存中恢复任务结果。"
  }, {
    "heading": "",
    "content": "¥Turborepo uses caching to speed up builds, ensuring you never do the same work twice. When your task is cacheable, Turborepo will restore the results of your task from cache using a fingerprint from the first time the task ran."
  }, {
    "heading": "",
    "content": "Turborepo 的缓存功能可在本地工作时节省大量时间。 - 启用 远程缓存 后，其功能将更加强大，可以在你的整个团队和 CI 之间共享缓存。"
  }, {
    "heading": "",
    "content": "¥Turborepo's caching results in significant time savings when working locally - and is even more powerful when Remote Caching is enabled, sharing a cache among your entire team and CI."
  }, {
    "heading": "",
    "content": "在本页，你将了解："
  }, {
    "heading": "",
    "content": "¥On this page, you'll learn:"
  }, {
    "heading": "",
    "content": "如何访问你的第一个 Turborepo 缓存"
  }, {
    "heading": "",
    "content": "¥How to hit your first Turborepo cache"
  }, {
    "heading": "",
    "content": "如何启用远程缓存"
  }, {
    "heading": "",
    "content": "¥How to enable Remote Caching"
  }, {
    "heading": "",
    "content": "Turborepo 使用什么作为哈希的输入和输出"
  }, {
    "heading": "",
    "content": "¥What Turborepo uses for the inputs and outputs to a hash"
  }, {
    "heading": "",
    "content": "如何排除缓存问题"
  }, {
    "heading": "",
    "content": "¥How to troubleshoot caching issues"
  }, {
    "heading": "",
    "content": "Turborepo 假定你的任务是确定性的。如果任务能够根据 Turborepo 识别的输入集产生不同的输出，则缓存可能无法按预期工作。"
  }, {
    "heading": "",
    "content": "¥Turborepo assumes that your tasks are deterministic. If a task is able to\nproduce different outputs given the set of inputs that Turborepo is aware of,\ncaching may not work as expected."
  }, {
    "heading": "访问你的第一个-turborepo-缓存-hit-your-first-turborepo-cache",
    "content": "¥Hit your first Turborepo cache"
  }, {
    "heading": "访问你的第一个-turborepo-缓存-hit-your-first-turborepo-cache",
    "content": "你可以通过三个步骤尝试 Turborepo 的缓存行为："
  }, {
    "heading": "访问你的第一个-turborepo-缓存-hit-your-first-turborepo-cache",
    "content": "¥You can try out Turborepo's caching behavior in three steps:"
  }, {
    "heading": "创建一个新的-turborepo-项目-create-a-new-turborepo-project",
    "content": "¥Create a new Turborepo project"
  }, {
    "heading": "创建一个新的-turborepo-项目-create-a-new-turborepo-project",
    "content": "使用 npx create-turbo@latest 并按照提示创建一个新的 Turborepo。"
  }, {
    "heading": "创建一个新的-turborepo-项目-create-a-new-turborepo-project",
    "content": "¥Use npx create-turbo@latest and follow the prompts to create a new Turborepo."
  }, {
    "heading": "首次运行构建-run-a-build-for-the-first-time",
    "content": "¥Run a build for the first time"
  }, {
    "heading": "首次运行构建-run-a-build-for-the-first-time",
    "content": "如果你有 全局安装的 turbo，请在你的存储库中运行 turbo build。"
  }, {
    "heading": "首次运行构建-run-a-build-for-the-first-time",
    "content": "¥If you have turbo installed globally, run turbo build in your repository."
  }, {
    "heading": "首次运行构建-run-a-build-for-the-first-time",
    "content": "或者，你可以使用软件包管理器在 package.json 中运行 build 脚本。"
  }, {
    "heading": "首次运行构建-run-a-build-for-the-first-time",
    "content": "¥Alternatively, you can run the build script in package.json using your package manager."
  }, {
    "heading": "首次运行构建-run-a-build-for-the-first-time",
    "content": "这将导致缓存未命中，因为你之前从未在此存储库中使用 输入集 运行过 turbo。输入将转换为哈希值，以便在本地文件系统缓存或 远程缓存 中进行检查。"
  }, {
    "heading": "首次运行构建-run-a-build-for-the-first-time",
    "content": "¥This will result in a cache miss, since you've never ran turbo before with this set of inputs in this repository. The inputs are turned into a hash to check for in your local filesystem cache or in the Remote Cache."
  }, {
    "heading": "访问缓存-hit-the-cache",
    "content": "¥Hit the cache"
  }, {
    "heading": "访问缓存-hit-the-cache",
    "content": "再次运行 turbo build。你将看到如下消息："
  }, {
    "heading": "访问缓存-hit-the-cache",
    "content": "¥Run turbo build again. You will see a message like this:"
  }, {
    "heading": "访问缓存-hit-the-cache",
    "content": "由于输入的指纹已在缓存中，因此无需再次从零开始重建应用。你可以从缓存中恢复上次构建的结果，从而节省资源和时间。"
  }, {
    "heading": "访问缓存-hit-the-cache",
    "content": "¥Because the inputs' fingerprint is already in the cache, there's no reason to rebuild your applications from zero again. You can restore the results of the previous build from cache, saving resources and time."
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥Remote Caching"
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "Turborepo 将任务结果存储在你计算机上的 .turbo/cache 目录中。但是，你可以通过与团队成员和持续集成 (CI) 共享此缓存，进一步加快整个组织的运行速度。"
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥Turborepo stores the results of tasks in the .turbo/cache directory on your machine. However, you can make your entire organization even faster by sharing this cache with your teammates and CI."
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "要了解更多关于远程缓存及其优势的信息，请访问 远程缓存页面。"
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥To learn more about Remote Caching and its benefits, visit the Remote Caching page."
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "¥Enabling Remote Cache"
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "首先，使用你的远程缓存提供程序进行身份验证："
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "¥First, authenticate with your Remote Cache provider:"
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "然后，将你机器上的仓库链接到远程缓存："
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "¥Then, link the repository on your machine to Remote Cache:"
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "现在，当你运行任务时，Turborepo 会自动将任务的输出发送到远程缓存。如果你在另一台也已通过远程缓存身份验证的计算机上运行相同的任务，它将在第一次运行该任务时命中缓存。"
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "¥Now, when you run a task, Turborepo will automatically send the outputs of the task to Remote Cache. If you run the same task on a different machine that is also authenticated to your Remote Cache, it will hit cache the first time it runs the task."
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "有关如何将你的 CI 机器连接到远程缓存的信息，请访问 构建 CI 指南。"
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "¥For information on how to connect your CI machines to Remote Cache, visit the Constructing CI guide."
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "默认情况下，Turborepo 使用零配置的 Vercel 远程缓存。如果你想使用其他远程缓存，请访问 远程缓存 API 文档"
  }, {
    "heading": "启用远程缓存-enabling-remote-cache",
    "content": "¥By default, Turborepo uses Vercel Remote\nCache with zero\nconfiguration. If you'd like to use a different Remote Cache, visit the\nRemote Caching API\ndocumentation"
  }, {
    "heading": "哪些内容会被缓存-what-gets-cached",
    "content": "¥What gets cached?"
  }, {
    "heading": "哪些内容会被缓存-what-gets-cached",
    "content": "Turborepo 缓存两种类型的输出：任务输出和日志。"
  }, {
    "heading": "哪些内容会被缓存-what-gets-cached",
    "content": "¥Turborepo caches two types of outputs: Task outputs and Logs."
  }, {
    "heading": "任务输出-task-outputs",
    "content": "¥Task outputs"
  }, {
    "heading": "任务输出-task-outputs",
    "content": "Turborepo 会缓存在 turbo.json 的 outputs 键 中定义的任务的文件输出。当缓存命中时，Turborepo 将从缓存中恢复文件。"
  }, {
    "heading": "任务输出-task-outputs",
    "content": "¥Turborepo caches the file outputs of a task that are defined in the outputs key of turbo.json. When there's a cache hit, Turborepo will restore the files from the cache."
  }, {
    "heading": "任务输出-task-outputs",
    "content": "outputs 键是可选的，请参阅 API 参考 了解 Turborepo 在这种情况下的行为。"
  }, {
    "heading": "任务输出-task-outputs",
    "content": "¥The outputs key is optional, see the API reference for how Turborepo behaves in this case."
  }, {
    "heading": "任务输出-task-outputs",
    "content": "如果你没有为任务声明文件输出，Turborepo 将不会缓存它们。对于某些任务（例如 linters）来说，这可能没问题。 - 但许多任务会生成你希望缓存的文件。"
  }, {
    "heading": "任务输出-task-outputs",
    "content": "¥If you do not declare file outputs for a task, Turborepo will not cache them. This might be okay for some tasks (like linters) - but many tasks produce files that you will want to be cached."
  }, {
    "heading": "任务输出-task-outputs",
    "content": "如果你在缓存时遇到文件不可用的错误，请确保你已定义任务的输出。"
  }, {
    "heading": "任务输出-task-outputs",
    "content": "¥If you're running into errors with files not being available when you hit cache, make sure that you have defined the outputs for your task."
  }, {
    "heading": "日志-logs",
    "content": "¥Logs"
  }, {
    "heading": "日志-logs",
    "content": "Turborepo 始终捕获任务的终端输出，并从任务首次运行时将这些日志恢复到你的终端。"
  }, {
    "heading": "日志-logs",
    "content": "¥Turborepo always captures the terminal outputs of your tasks, restoring those logs to your terminal from the first time that the task ran."
  }, {
    "heading": "日志-logs",
    "content": "你可以使用 --output-logs 标志 或 outputLogs 配置选项 配置重放日志的详细程度。"
  }, {
    "heading": "日志-logs",
    "content": "¥You can configure the verbosity of the replayed logs using the --output-logs flag or outputLogs configuration option."
  }, {
    "heading": "任务输入-task-inputs",
    "content": "¥Task inputs"
  }, {
    "heading": "任务输入-task-inputs",
    "content": "Turborepo 会对输入进行哈希处理，从而为任务运行创建一个 \"fingerprint\" 文件。当 \"fingerprints\" 匹配时，运行任务将会命中缓存。"
  }, {
    "heading": "任务输入-task-inputs",
    "content": "¥Inputs are hashed by Turborepo, creating a \"fingerprint\" for the task run. When \"fingerprints\" match, running the task will hit the cache."
  }, {
    "heading": "任务输入-task-inputs",
    "content": "Turborepo 在底层创建了两个哈希值：一个全局哈希和一个任务哈希。如果其中一个哈希值发生变化，任务将丢失缓存。"
  }, {
    "heading": "任务输入-task-inputs",
    "content": "¥Under the hood, Turborepo creates two hashes: a global hash and a task hash. If either of the hashes change, the task will miss cache."
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "¥Global hash inputs"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "输入"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "示例"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "从根目录 turbo.json 和软件包 turbo.json 解析任务定义"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "在根 turbo.json 或 软件包配置 中更改 outputs"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "影响工作区根目录的锁文件变更"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "更新根 package.json 中的依赖将导致所有任务缓存丢失"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "globalDependencies 文件内容"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "当 ./.env 在 globalDependencies 中列出时，更改 ./.env 将导致所有任务缓存丢失"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "globalEnv 中列出的变量值"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "当 GITHUB_TOKEN 在 globalEnv 中列出时，更改 GITHUB_TOKEN 的值"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "标记影响任务运行时的值"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "使用行为更改标志，例如 --cache-dir、--framework-inference 或 --env-mode"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "任意传递参数"
  }, {
    "heading": "全局哈希输入-global-hash-inputs",
    "content": "与 turbo build 或 turbo build -- --arg=diff 相比，turbo build -- --arg=value 会导致所有任务缓存未命中（包括未收到 --arg=value 的 build 的依赖）"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "¥Package hash inputs"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "输入"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "示例"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "软件包配置 更改"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "更改软件包的 turbo.json"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "影响软件包的锁文件变更"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "更新包的 package.json 中的依赖"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "包的 package.json 更改"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "更新包的 package.json 中的 name 字段"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "源代码管理中的文件变更"
  }, {
    "heading": "软件包哈希值输入-package-hash-inputs",
    "content": "在 src/index.ts 中编写新代码"
  }, {
    "heading": "故障排除-troubleshooting",
    "content": "¥Troubleshooting"
  }, {
    "heading": "使用试运行-using-dry-runs",
    "content": "¥Using dry runs"
  }, {
    "heading": "使用试运行-using-dry-runs",
    "content": "Turborepo 有一个 --dry 标志，可用于查看在不实际运行任务的情况下运行任务时会发生什么。当你不确定正在运行哪些任务时，这对于调试缓存问题非常有用。"
  }, {
    "heading": "使用试运行-using-dry-runs",
    "content": "¥Turborepo has a --dry flag that can be used to see what would happen if you ran a task without actually running it. This can be useful for debugging caching issues when you're not sure which tasks you're running."
  }, {
    "heading": "使用试运行-using-dry-runs",
    "content": "更多详情，请访问 --dry API 参考。"
  }, {
    "heading": "使用试运行-using-dry-runs",
    "content": "¥For more details, visit the --dry API reference."
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "¥Using Run Summaries"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "Turborepo 有一个 --summarize 标志，可用于概览任务的所有输入、输出等。比较两个摘要将显示两个任务哈希值不同的原因。这可以用于："
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "¥Turborepo has a --summarize flag that can be used to get an overview of all of a task's inputs, outputs, and more. Comparing two summaries will show why two task's hashes are different. This can be useful for:"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "调试输入：Turborepo 中的任务有很多输入。如果任务在你预期命中时丢失了缓存，你可以使用运行摘要来检查哪些输入与你预期的不同。"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "¥Debugging inputs: There are many inputs to a task in Turborepo. If a task is missing cache when you expect it to hit, you can use a Run Summary to check which inputs are different that you weren't expecting."
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "调试输出：如果缓存命中未恢复你期望的文件，运行摘要可以帮助你了解从缓存中恢复的输出。"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "¥Debugging outputs: If cache hits aren't restoring the files you're expecting, a Run Summary can help you understand what outputs are being restored from cache."
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "虽然 Turborepo 本身没有运行摘要 UI 查看器，但有一些社区开发的工具可供使用："
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "¥While there is not a Turborepo-native Run Summaries UI viewer, there are\nseveral community-built tools available:"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "https://turbo.nullvoxpopuli.com - 基于 Web 的运行摘要 UI 查看器"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "¥https://turbo.nullvoxpopuli.com - Web-based UI viewer for Run Summaries"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "turborepo-summary - 从 Turborepo 运行摘要 JSON 输出生成易于阅读的报告"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "¥turborepo-summary - Generate human-readable reports from Turborepo run summary JSON output"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "turborepo-summary-action - GitHub Action 将 turborepo-summary 封装起来，并将其附加到 GitHub Actions 作业摘要"
  }, {
    "heading": "使用运行摘要-using-run-summaries",
    "content": "¥turborepo-summary-action - GitHub Action wrapping turborepo-summary to append them to GitHub Actions Job Summary"
  }, {
    "heading": "关闭缓存-turning-off-caching",
    "content": "¥Turning off caching"
  }, {
    "heading": "关闭缓存-turning-off-caching",
    "content": "有时，你可能不想将任务的输出写入缓存。这可以永久设置为使用 \"cache\": false 的任务或使用 --cache <options> 标志 的整个运行。"
  }, {
    "heading": "关闭缓存-turning-off-caching",
    "content": "¥Sometimes, you may not want to write the output of tasks to the cache. This can be set permanently for a task using \"cache\": false or for a whole run using  the --cache <options> flag."
  }, {
    "heading": "覆盖缓存-overwriting-a-cache",
    "content": "¥Overwriting a cache"
  }, {
    "heading": "覆盖缓存-overwriting-a-cache",
    "content": "如果你想强制 turbo 重新执行已缓存的任务，请使用 --force 标志。请注意，这将禁用读取缓存，而不是写入缓存。"
  }, {
    "heading": "覆盖缓存-overwriting-a-cache",
    "content": "¥If you want to force turbo to re-execute a task that has been cached, use the --force flag. Note that this disables reading the cache, not writing."
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "¥Caching a task is slower than executing the task"
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "也有可能出现缓存比不缓存更慢的情况。这种情况很少见，但以下是一些示例："
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "¥It's possible to create scenarios where caching ends up being slower than not caching. These cases are rare, but a few examples include:"
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "执行速度极快的任务：如果任务的执行速度快于与 远程缓存 的网络往返速度，则应考虑不缓存该任务。"
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "¥Tasks that execute extremely fast: If a task executes faster than a network round-trip to the Remote Cache, you should consider not caching the task."
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "输出资源巨大的任务：有可能创建一个非常大的工件，以至于上传或下载它的时间超过了重新生成它的时间，例如一个完整的 Docker 容器。在这些情况下，你应该考虑不缓存该任务。"
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "¥Tasks whose output assets are enormous: It's possible to create an artifact that is so big that the time to upload or download it exceeds the time to regenerate it, like a complete Docker Container. In these cases, you should consider not caching the task."
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "具有自身缓存的脚本：某些任务有自己的内部缓存行为。在这些情况下，为了使 Turborepo 的缓存和应用缓存协同工作，配置很快就会变得复杂。"
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "¥Scripts that have their own caching: Some tasks have their own internal caching behavior. In these cases, configuration can quickly become complicated to make Turborepo's cache and the application cache work together."
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "虽然这些情况很少见，但请务必测试项目的行为，以确定在特定位置禁用缓存是否能带来性能提升。"
  }, {
    "heading": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "¥While these situations are rare, be sure to test the behavior of your projects to determine if disabling caching in specific places provides a performance benefit."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "现在你已经了解了 Turborepo 的缓存如何使你的存储库更快，让我们来看看如何在 Turborepo 中开发应用和库。"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Now that you've seen how Turborepo's caching makes your repository faster, let's take a look at how to develop applications and libraries in your Turborepo."
  }],
  "headings": [{
    "id": "访问你的第一个-turborepo-缓存-hit-your-first-turborepo-cache",
    "content": "访问你的第一个 Turborepo 缓存 /*hit-your-first-turborepo-cache*/"
  }, {
    "id": "创建一个新的-turborepo-项目-create-a-new-turborepo-project",
    "content": "创建一个新的 Turborepo 项目 /*create-a-new-turborepo-project*/"
  }, {
    "id": "首次运行构建-run-a-build-for-the-first-time",
    "content": "首次运行构建 /*run-a-build-for-the-first-time*/"
  }, {
    "id": "访问缓存-hit-the-cache",
    "content": "访问缓存 /*hit-the-cache*/"
  }, {
    "id": "远程缓存-remote-caching",
    "content": "远程缓存 /*remote-caching*/"
  }, {
    "id": "启用远程缓存-enabling-remote-cache",
    "content": "启用远程缓存 /*enabling-remote-cache*/"
  }, {
    "id": "哪些内容会被缓存-what-gets-cached",
    "content": "哪些内容会被缓存？ /*what-gets-cached*/"
  }, {
    "id": "任务输出-task-outputs",
    "content": "任务输出 /*task-outputs*/"
  }, {
    "id": "日志-logs",
    "content": "日志 /*logs*/"
  }, {
    "id": "任务输入-task-inputs",
    "content": "任务输入 /*task-inputs*/"
  }, {
    "id": "全局哈希输入-global-hash-inputs",
    "content": "全局哈希输入 /*global-hash-inputs*/"
  }, {
    "id": "软件包哈希值输入-package-hash-inputs",
    "content": "软件包哈希值输入 /*package-hash-inputs*/"
  }, {
    "id": "故障排除-troubleshooting",
    "content": "故障排除 /*troubleshooting*/"
  }, {
    "id": "使用试运行-using-dry-runs",
    "content": "使用试运行 /*using-dry-runs*/"
  }, {
    "id": "使用运行摘要-using-run-summaries",
    "content": "使用运行摘要 /*using-run-summaries*/"
  }, {
    "id": "关闭缓存-turning-off-caching",
    "content": "关闭缓存 /*turning-off-caching*/"
  }, {
    "id": "覆盖缓存-overwriting-a-cache",
    "content": "覆盖缓存 /*overwriting-a-cache*/"
  }, {
    "id": "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
    "content": "缓存任务比执行任务慢 /*caching-a-task-is-slower-than-executing-the-task*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import __img0 from "./../../../public/images/docs/why-turborepo-solution.png";
import __img1 from "./../../../public/images/docs/full-turbo.png";
import {Step, Steps} from '#components/steps';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#访问你的第一个-turborepo-缓存-hit-your-first-turborepo-cache",
  title: _jsx(_Fragment, {
    children: "访问你的第一个 Turborepo 缓存 "
  })
}, {
  depth: 3,
  url: "#创建一个新的-turborepo-项目-create-a-new-turborepo-project",
  title: _jsx(_Fragment, {
    children: "创建一个新的 Turborepo 项目 "
  })
}, {
  depth: 3,
  url: "#首次运行构建-run-a-build-for-the-first-time",
  title: _jsx(_Fragment, {
    children: "首次运行构建 "
  })
}, {
  depth: 3,
  url: "#访问缓存-hit-the-cache",
  title: _jsx(_Fragment, {
    children: "访问缓存 "
  })
}, {
  depth: 2,
  url: "#远程缓存-remote-caching",
  title: _jsx(_Fragment, {
    children: "远程缓存 "
  })
}, {
  depth: 3,
  url: "#启用远程缓存-enabling-remote-cache",
  title: _jsx(_Fragment, {
    children: "启用远程缓存 "
  })
}, {
  depth: 2,
  url: "#哪些内容会被缓存-what-gets-cached",
  title: _jsx(_Fragment, {
    children: "哪些内容会被缓存？ "
  })
}, {
  depth: 3,
  url: "#任务输出-task-outputs",
  title: _jsx(_Fragment, {
    children: "任务输出 "
  })
}, {
  depth: 3,
  url: "#日志-logs",
  title: _jsx(_Fragment, {
    children: "日志 "
  })
}, {
  depth: 2,
  url: "#任务输入-task-inputs",
  title: _jsx(_Fragment, {
    children: "任务输入 "
  })
}, {
  depth: 3,
  url: "#全局哈希输入-global-hash-inputs",
  title: _jsx(_Fragment, {
    children: "全局哈希输入 "
  })
}, {
  depth: 3,
  url: "#软件包哈希值输入-package-hash-inputs",
  title: _jsx(_Fragment, {
    children: "软件包哈希值输入 "
  })
}, {
  depth: 2,
  url: "#故障排除-troubleshooting",
  title: _jsx(_Fragment, {
    children: "故障排除 "
  })
}, {
  depth: 3,
  url: "#使用试运行-using-dry-runs",
  title: _jsx(_Fragment, {
    children: "使用试运行 "
  })
}, {
  depth: 3,
  url: "#使用运行摘要-using-run-summaries",
  title: _jsx(_Fragment, {
    children: "使用运行摘要 "
  })
}, {
  depth: 3,
  url: "#关闭缓存-turning-off-caching",
  title: _jsx(_Fragment, {
    children: "关闭缓存 "
  })
}, {
  depth: 3,
  url: "#覆盖缓存-overwriting-a-cache",
  title: _jsx(_Fragment, {
    children: "覆盖缓存 "
  })
}, {
  depth: 3,
  url: "#缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
  title: _jsx(_Fragment, {
    children: "缓存任务比执行任务慢 "
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Turborepo 使用缓存来加速构建，确保你不会重复执行相同的工作。当你的任务可缓存时，Turborepo 将使用任务首次运行时的指纹从缓存中恢复任务结果。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo uses caching to speed up builds, ensuring you ", _jsx(_components.strong, {
        children: "never do the same work twice"
      }), ". When your task is cacheable, Turborepo will restore the results of your task from cache using a fingerprint from the first time the task ran."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "12 tasks are being ran in 3 packages, resulting in a \">>> FULL TURBO\" cache hit. The total time it takes to restore these tasks from cache is 80 milliseconds.",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 的缓存功能可在本地工作时节省大量时间。 - 启用 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "远程缓存"
      }), " 后，其功能将更加强大，可以在你的整个团队和 CI 之间共享缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo's caching results in significant time savings when working locally - and is even more powerful when ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), " is enabled, sharing a cache among your entire team and CI."]
    }), "\n", _jsx(_components.p, {
      children: "在本页，你将了解："
    }), "\n", _jsx(_components.p, {
      children: "¥On this page, you'll learn:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#hit-your-first-turborepo-cache",
            children: "如何访问你的第一个 Turborepo 缓存"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#hit-your-first-turborepo-cache",
            children: "How to hit your first Turborepo cache"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/core-concepts/remote-caching",
            children: "如何启用远程缓存"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/core-concepts/remote-caching",
            children: "How to enable Remote Caching"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/crafting-your-repository/caching#task-inputs",
            children: "Turborepo 使用什么作为哈希的输入和输出"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/caching#task-inputs",
            children: "What Turborepo uses for the inputs and outputs to a hash"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#troubleshooting",
            children: "如何排除缓存问题"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#troubleshooting",
            children: "How to troubleshoot caching issues"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsx(_components.p, {
        children: "Turborepo 假定你的任务是确定性的。如果任务能够根据 Turborepo 识别的输入集产生不同的输出，则缓存可能无法按预期工作。"
      }), _jsxs(_components.p, {
        children: ["¥Turborepo assumes that your tasks are ", _jsx(_components.strong, {
          children: "deterministic"
        }), ". If a task is able to\nproduce different outputs given the set of inputs that Turborepo is aware of,\ncaching may not work as expected."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "访问你的第一个-turborepo-缓存-hit-your-first-turborepo-cache",
      children: "访问你的第一个 Turborepo 缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Hit your first Turborepo cache"
    }), "\n", _jsx(_components.p, {
      children: "你可以通过三个步骤尝试 Turborepo 的缓存行为："
    }), "\n", _jsx(_components.p, {
      children: "¥You can try out Turborepo's caching behavior in three steps:"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "创建一个新的-turborepo-项目-create-a-new-turborepo-project",
          children: "创建一个新的 Turborepo 项目 "
        }), _jsx(_components.p, {
          children: "¥Create a new Turborepo project"
        }), _jsxs(_components.p, {
          children: ["使用 ", _jsx(_components.code, {
            children: "npx create-turbo@latest"
          }), " 并按照提示创建一个新的 Turborepo。"]
        }), _jsxs(_components.p, {
          children: ["¥Use ", _jsx(_components.code, {
            children: "npx create-turbo@latest"
          }), " and follow the prompts to create a new Turborepo."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "首次运行构建-run-a-build-for-the-first-time",
          children: "首次运行构建 "
        }), _jsx(_components.p, {
          children: "¥Run a build for the first time"
        }), _jsxs(_components.p, {
          children: ["如果你有 ", _jsxs(_components.a, {
            href: "/docs/getting-started/installation#global-installation",
            children: ["全局安装的 ", _jsx(_components.code, {
              children: "turbo"
            })]
          }), "，请在你的存储库中运行 ", _jsx(_components.code, {
            children: "turbo build"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥If you have ", _jsxs(_components.a, {
            href: "/docs/getting-started/installation#global-installation",
            children: [_jsx(_components.code, {
              children: "turbo"
            }), " installed globally"]
          }), ", run ", _jsx(_components.code, {
            children: "turbo build"
          }), " in your repository."]
        }), _jsxs(_components.p, {
          children: ["或者，你可以使用软件包管理器在 ", _jsx(_components.code, {
            children: "package.json"
          }), " 中运行 ", _jsx(_components.code, {
            children: "build"
          }), " 脚本。"]
        }), _jsxs(_components.p, {
          children: ["¥Alternatively, you can run the ", _jsx(_components.code, {
            children: "build"
          }), " script in ", _jsx(_components.code, {
            children: "package.json"
          }), " using your package manager."]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " run"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " build"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " build"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " run"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " build"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " run"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " build"
                    })]
                  })
                })
              })
            })
          })]
        }), _jsxs(_components.p, {
          children: ["这将导致缓存未命中，因为你之前从未在此存储库中使用 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/caching#task-inputs",
            children: "输入集"
          }), " 运行过 ", _jsx(_components.code, {
            children: "turbo"
          }), "。输入将转换为哈希值，以便在本地文件系统缓存或 ", _jsx(_components.a, {
            href: "/docs/core-concepts/remote-caching",
            children: "远程缓存"
          }), " 中进行检查。"]
        }), _jsxs(_components.p, {
          children: ["¥This will result in a cache miss, since you've never ran ", _jsx(_components.code, {
            children: "turbo"
          }), " before with this ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/caching#task-inputs",
            children: "set of inputs"
          }), " in this repository. The inputs are turned into a hash to check for in your local filesystem cache or in ", _jsx(_components.a, {
            href: "/docs/core-concepts/remote-caching",
            children: "the Remote Cache"
          }), "."]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "访问缓存-hit-the-cache",
          children: "访问缓存 "
        }), _jsx(_components.p, {
          children: "¥Hit the cache"
        }), _jsxs(_components.p, {
          children: ["再次运行 ", _jsx(_components.code, {
            children: "turbo build"
          }), "。你将看到如下消息："]
        }), _jsxs(_components.p, {
          children: ["¥Run ", _jsx(_components.code, {
            children: "turbo build"
          }), " again. You will see a message like this:"]
        }), _jsx(_components.p, {
          children: _jsx(_components.img, {
            alt: "A terminal window showing two tasks that have been ran through turbo. They successfully complete in 116 milliseconds.",
            placeholder: "blur",
            src: __img1
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "由于输入的指纹已在缓存中，因此无需再次从零开始重建应用。你可以从缓存中恢复上次构建的结果，从而节省资源和时间。"
    }), "\n", _jsx(_components.p, {
      children: "¥Because the inputs' fingerprint is already in the cache, there's no reason to rebuild your applications from zero again. You can restore the results of the previous build from cache, saving resources and time."
    }), "\n", _jsx(_components.h2, {
      id: "远程缓存-remote-caching",
      children: "远程缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Remote Caching"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 将任务结果存储在你计算机上的 ", _jsx(_components.code, {
        children: ".turbo/cache"
      }), " 目录中。但是，你可以通过与团队成员和持续集成 (CI) 共享此缓存，进一步加快整个组织的运行速度。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo stores the results of tasks in the ", _jsx(_components.code, {
        children: ".turbo/cache"
      }), " directory on your machine. However, you can make your entire organization even faster by sharing this cache with your teammates and CI."]
    }), "\n", _jsxs(_components.p, {
      children: ["要了解更多关于远程缓存及其优势的信息，请访问 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "远程缓存页面"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To learn more about Remote Caching and its benefits, visit the ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching page"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "启用远程缓存-enabling-remote-cache",
      children: "启用远程缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Enabling Remote Cache"
    }), "\n", _jsx(_components.p, {
      children: "首先，使用你的远程缓存提供程序进行身份验证："
    }), "\n", _jsx(_components.p, {
      children: "¥First, authenticate with your Remote Cache provider:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "然后，将你机器上的仓库链接到远程缓存："
    }), "\n", _jsx(_components.p, {
      children: "¥Then, link the repository on your machine to Remote Cache:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "现在，当你运行任务时，Turborepo 会自动将任务的输出发送到远程缓存。如果你在另一台也已通过远程缓存身份验证的计算机上运行相同的任务，它将在第一次运行该任务时命中缓存。"
    }), "\n", _jsx(_components.p, {
      children: "¥Now, when you run a task, Turborepo will automatically send the outputs of the task to Remote Cache. If you run the same task on a different machine that is also authenticated to your Remote Cache, it will hit cache the first time it runs the task."
    }), "\n", _jsxs(_components.p, {
      children: ["有关如何将你的 CI 机器连接到远程缓存的信息，请访问 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/constructing-ci#enabling-remote-caching",
        children: "构建 CI 指南"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For information on how to connect your CI machines to Remote Cache, visit ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/constructing-ci#enabling-remote-caching",
        children: "the Constructing CI guide"
      }), "."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["默认情况下，Turborepo 使用零配置的 ", _jsx(_components.a, {
          href: "https://vercel.com/docs/monorepos/remote-caching",
          children: "Vercel 远程缓存"
        }), "。如果你想使用其他远程缓存，请访问 ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching#self-hosting",
          children: "远程缓存 API 文档"
        })]
      }), _jsxs(_components.p, {
        children: ["¥By default, Turborepo uses ", _jsx(_components.a, {
          href: "https://vercel.com/docs/monorepos/remote-caching",
          children: "Vercel Remote\nCache"
        }), " with zero\nconfiguration. If you'd like to use a different Remote Cache, visit the\n", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching#self-hosting",
          children: "Remote Caching API\ndocumentation"
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "哪些内容会被缓存-what-gets-cached",
      children: "哪些内容会被缓存？ "
    }), "\n", _jsx(_components.p, {
      children: "¥What gets cached?"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 缓存两种类型的输出：任务输出和日志。"
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo caches two types of outputs: Task outputs and Logs."
    }), "\n", _jsx(_components.h3, {
      id: "任务输出-task-outputs",
      children: "任务输出 "
    }), "\n", _jsx(_components.p, {
      children: "¥Task outputs"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 会缓存在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 的 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: [_jsx(_components.code, {
          children: "outputs"
        }), " 键"]
      }), " 中定义的任务的文件输出。当缓存命中时，Turborepo 将从缓存中恢复文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo caches the file outputs of a task that are defined in ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: ["the ", _jsx(_components.code, {
          children: "outputs"
        }), " key"]
      }), " of ", _jsx(_components.code, {
        children: "turbo.json"
      }), ". When there's a cache hit, Turborepo will restore the files from the cache."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "outputs"
      }), " 键是可选的，请参阅 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: "API 参考"
      }), " 了解 Turborepo 在这种情况下的行为。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "outputs"
      }), " key is optional, see ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: "the API reference"
      }), " for how Turborepo behaves in this case."]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      title: "Providing file outputs",
      children: [_jsx(_components.p, {
        children: "如果你没有为任务声明文件输出，Turborepo 将不会缓存它们。对于某些任务（例如 linters）来说，这可能没问题。 - 但许多任务会生成你希望缓存的文件。"
      }), _jsx(_components.p, {
        children: "¥If you do not declare file outputs for a task, Turborepo will not cache them. This might be okay for some tasks (like linters) - but many tasks produce files that you will want to be cached."
      }), _jsx(_components.p, {
        children: "如果你在缓存时遇到文件不可用的错误，请确保你已定义任务的输出。"
      }), _jsx(_components.p, {
        children: "¥If you're running into errors with files not being available when you hit cache, make sure that you have defined the outputs for your task."
      })]
    }), "\n", _jsx(_components.h3, {
      id: "日志-logs",
      children: "日志 "
    }), "\n", _jsx(_components.p, {
      children: "¥Logs"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 始终捕获任务的终端输出，并从任务首次运行时将这些日志恢复到你的终端。"
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo always captures the terminal outputs of your tasks, restoring those logs to your terminal from the first time that the task ran."
    }), "\n", _jsxs(_components.p, {
      children: ["你可以使用 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--output-logs-option",
        children: [_jsx(_components.code, {
          children: "--output-logs"
        }), " 标志"]
      }), " 或 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputlogs",
        children: [_jsx(_components.code, {
          children: "outputLogs"
        }), " 配置选项"]
      }), " 配置重放日志的详细程度。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can configure the verbosity of the replayed logs using ", _jsxs(_components.a, {
        href: "/docs/reference/run#--output-logs-option",
        children: ["the ", _jsx(_components.code, {
          children: "--output-logs"
        }), " flag"]
      }), " or ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputlogs",
        children: [_jsx(_components.code, {
          children: "outputLogs"
        }), " configuration option"]
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "任务输入-task-inputs",
      children: "任务输入 "
    }), "\n", _jsx(_components.p, {
      children: "¥Task inputs"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 会对输入进行哈希处理，从而为任务运行创建一个 \"fingerprint\" 文件。当 \"fingerprints\" 匹配时，运行任务将会命中缓存。"
    }), "\n", _jsx(_components.p, {
      children: "¥Inputs are hashed by Turborepo, creating a \"fingerprint\" for the task run. When \"fingerprints\" match, running the task will hit the cache."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 在底层创建了两个哈希值：一个全局哈希和一个任务哈希。如果其中一个哈希值发生变化，任务将丢失缓存。"
    }), "\n", _jsx(_components.p, {
      children: "¥Under the hood, Turborepo creates two hashes: a global hash and a task hash. If either of the hashes change, the task will miss cache."
    }), "\n", _jsx(_components.h3, {
      id: "全局哈希输入-global-hash-inputs",
      children: "全局哈希输入 "
    }), "\n", _jsx(_components.p, {
      children: "¥Global hash inputs"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "输入"
          }), _jsx(_components.th, {
            children: "示例"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: ["从根目录 ", _jsx(_components.code, {
              children: "turbo.json"
            }), _jsx("br", {}), " 和软件包 ", _jsx(_components.code, {
              children: "turbo.json"
            }), " 解析任务定义"]
          }), _jsxs(_components.td, {
            children: ["在根 ", _jsx(_components.code, {
              children: "turbo.json"
            }), " 或 ", _jsx(_components.a, {
              href: "/docs/reference/package-configurations",
              children: "软件包配置"
            }), " 中更改 ", _jsx(_components.a, {
              href: "/docs/reference/configuration#outputs",
              children: _jsx(_components.code, {
                children: "outputs"
              })
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "影响工作区根目录的锁文件变更"
          }), _jsxs(_components.td, {
            children: ["更新根 ", _jsx(_components.code, {
              children: "package.json"
            }), " 中的依赖将导致所有任务缓存丢失"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "/docs/reference/configuration#globaldependencies",
              children: _jsx(_components.code, {
                children: "globalDependencies"
              })
            }), " 文件内容"]
          }), _jsxs(_components.td, {
            children: ["当 ", _jsx(_components.code, {
              children: "./.env"
            }), " 在 ", _jsx(_components.code, {
              children: "globalDependencies"
            }), " 中列出时，更改 ", _jsx(_components.code, {
              children: "./.env"
            }), " 将导致所有任务缓存丢失"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "/docs/reference/configuration#globalenv",
              children: _jsx(_components.code, {
                children: "globalEnv"
              })
            }), " 中列出的变量值"]
          }), _jsxs(_components.td, {
            children: ["当 ", _jsx(_components.code, {
              children: "GITHUB_TOKEN"
            }), " 在 ", _jsx(_components.code, {
              children: "globalEnv"
            }), " 中列出时，更改 ", _jsx(_components.code, {
              children: "GITHUB_TOKEN"
            }), " 的值"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "标记影响任务运行时的值"
          }), _jsxs(_components.td, {
            children: ["使用行为更改标志，例如 ", _jsx(_components.code, {
              children: "--cache-dir"
            }), "、", _jsx(_components.code, {
              children: "--framework-inference"
            }), " 或 ", _jsx(_components.code, {
              children: "--env-mode"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "任意传递参数"
          }), _jsxs(_components.td, {
            children: ["与 ", _jsx(_components.code, {
              children: "turbo build"
            }), " 或 ", _jsx(_components.code, {
              children: "turbo build -- --arg=diff"
            }), " 相比，", _jsx(_components.code, {
              children: "turbo build -- --arg=value"
            }), " 会导致所有任务缓存未命中（包括未收到 ", _jsx(_components.code, {
              children: "--arg=value"
            }), " 的 ", _jsx(_components.code, {
              children: "build"
            }), " 的依赖）"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "软件包哈希值输入-package-hash-inputs",
      children: "软件包哈希值输入 "
    }), "\n", _jsx(_components.p, {
      children: "¥Package hash inputs"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "输入"
          }), _jsx(_components.th, {
            children: "示例"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "/docs/reference/package-configurations",
              children: "软件包配置"
            }), " 更改"]
          }), _jsxs(_components.td, {
            children: ["更改软件包的 ", _jsx(_components.code, {
              children: "turbo.json"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "影响软件包的锁文件变更"
          }), _jsxs(_components.td, {
            children: ["更新包的 ", _jsx(_components.code, {
              children: "package.json"
            }), " 中的依赖"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: ["包的 ", _jsx(_components.code, {
              children: "package.json"
            }), " 更改"]
          }), _jsxs(_components.td, {
            children: ["更新包的 ", _jsx(_components.code, {
              children: "package.json"
            }), " 中的 ", _jsx(_components.code, {
              children: "name"
            }), " 字段"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "源代码管理中的文件变更"
          }), _jsxs(_components.td, {
            children: ["在 ", _jsx(_components.code, {
              children: "src/index.ts"
            }), " 中编写新代码"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "故障排除-troubleshooting",
      children: "故障排除 "
    }), "\n", _jsx(_components.p, {
      children: "¥Troubleshooting"
    }), "\n", _jsx(_components.h3, {
      id: "使用试运行-using-dry-runs",
      children: "使用试运行 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using dry runs"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 有一个 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: [_jsx(_components.code, {
          children: "--dry"
        }), " 标志"]
      }), "，可用于查看在不实际运行任务的情况下运行任务时会发生什么。当你不确定正在运行哪些任务时，这对于调试缓存问题非常有用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo has a ", _jsxs(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: [_jsx(_components.code, {
          children: "--dry"
        }), " flag"]
      }), " that can be used to see what would happen if you ran a task without actually running it. This can be useful for debugging caching issues when you're not sure which tasks you're running."]
    }), "\n", _jsxs(_components.p, {
      children: ["更多详情，请访问 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: [_jsx(_components.code, {
          children: "--dry"
        }), " API 参考"]
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For more details, visit the ", _jsxs(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: [_jsx(_components.code, {
          children: "--dry"
        }), " API reference"]
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "使用运行摘要-using-run-summaries",
      children: "使用运行摘要 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using Run Summaries"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 有一个 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--summarize",
        children: [_jsx(_components.code, {
          children: "--summarize"
        }), " 标志"]
      }), "，可用于概览任务的所有输入、输出等。比较两个摘要将显示两个任务哈希值不同的原因。这可以用于："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo has a ", _jsxs(_components.a, {
        href: "/docs/reference/run#--summarize",
        children: [_jsx(_components.code, {
          children: "--summarize"
        }), " flag"]
      }), " that can be used to get an overview of all of a task's inputs, outputs, and more. Comparing two summaries will show why two task's hashes are different. This can be useful for:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "调试输入：Turborepo 中的任务有很多输入。如果任务在你预期命中时丢失了缓存，你可以使用运行摘要来检查哪些输入与你预期的不同。"
        }), "\n", _jsx(_components.p, {
          children: "¥Debugging inputs: There are many inputs to a task in Turborepo. If a task is missing cache when you expect it to hit, you can use a Run Summary to check which inputs are different that you weren't expecting."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "调试输出：如果缓存命中未恢复你期望的文件，运行摘要可以帮助你了解从缓存中恢复的输出。"
        }), "\n", _jsx(_components.p, {
          children: "¥Debugging outputs: If cache hits aren't restoring the files you're expecting, a Run Summary can help you understand what outputs are being restored from cache."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Summaries viewer",
      children: [_jsx(_components.p, {
        children: "虽然 Turborepo 本身没有运行摘要 UI 查看器，但有一些社区开发的工具可供使用："
      }), _jsx(_components.p, {
        children: "¥While there is not a Turborepo-native Run Summaries UI viewer, there are\nseveral community-built tools available:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.a, {
              href: "https://turbo.nullvoxpopuli.com",
              children: "https://turbo.nullvoxpopuli.com"
            }), " - 基于 Web 的运行摘要 UI 查看器"]
          }), "\n", _jsxs(_components.p, {
            children: ["¥", _jsx(_components.a, {
              href: "https://turbo.nullvoxpopuli.com",
              children: "https://turbo.nullvoxpopuli.com"
            }), " - Web-based UI viewer for Run Summaries"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.a, {
              href: "https://github.com/charpeni/turborepo-summary",
              children: _jsx(_components.code, {
                children: "turborepo-summary"
              })
            }), " - 从 Turborepo 运行摘要 JSON 输出生成易于阅读的报告"]
          }), "\n", _jsxs(_components.p, {
            children: ["¥", _jsx(_components.a, {
              href: "https://github.com/charpeni/turborepo-summary",
              children: _jsx(_components.code, {
                children: "turborepo-summary"
              })
            }), " - Generate human-readable reports from Turborepo run summary JSON output"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.a, {
              href: "https://github.com/charpeni/turborepo-summary-action",
              children: _jsx(_components.code, {
                children: "turborepo-summary-action"
              })
            }), " - GitHub Action 将 ", _jsx(_components.code, {
              children: "turborepo-summary"
            }), " 封装起来，并将其附加到 GitHub Actions 作业摘要"]
          }), "\n", _jsxs(_components.p, {
            children: ["¥", _jsx(_components.a, {
              href: "https://github.com/charpeni/turborepo-summary-action",
              children: _jsx(_components.code, {
                children: "turborepo-summary-action"
              })
            }), " - GitHub Action wrapping ", _jsx(_components.code, {
              children: "turborepo-summary"
            }), " to append them to GitHub Actions Job Summary"]
          }), "\n"]
        }), "\n"]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "关闭缓存-turning-off-caching",
      children: "关闭缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Turning off caching"
    }), "\n", _jsxs(_components.p, {
      children: ["有时，你可能不想将任务的输出写入缓存。这可以永久设置为使用 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#cache",
        children: _jsx(_components.code, {
          children: "\"cache\": false"
        })
      }), " 的任务或使用 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--no-cache",
        children: [_jsx(_components.code, {
          children: "--cache <options>"
        }), " 标志"]
      }), " 的整个运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Sometimes, you may not want to write the output of tasks to the cache. This can be set permanently for a task using ", _jsx(_components.a, {
        href: "/docs/reference/configuration#cache",
        children: _jsx(_components.code, {
          children: "\"cache\": false"
        })
      }), " or for a whole run using ", _jsxs(_components.a, {
        href: "/docs/reference/run#--no-cache",
        children: [" the ", _jsx(_components.code, {
          children: "--cache <options>"
        }), " flag"]
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "覆盖缓存-overwriting-a-cache",
      children: "覆盖缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Overwriting a cache"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你想强制 ", _jsx(_components.code, {
        children: "turbo"
      }), " 重新执行已缓存的任务，请使用 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--force",
        children: [_jsx(_components.code, {
          children: "--force"
        }), " 标志"]
      }), "。请注意，这将禁用读取缓存，而不是写入缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you want to force ", _jsx(_components.code, {
        children: "turbo"
      }), " to re-execute a task that has been cached, use ", _jsxs(_components.a, {
        href: "/docs/reference/run#--force",
        children: ["the ", _jsx(_components.code, {
          children: "--force"
        }), " flag"]
      }), ". Note that this disables ", _jsx(_components.strong, {
        children: "reading"
      }), " the cache, ", _jsx(_components.strong, {
        children: "not writing"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "缓存任务比执行任务慢-caching-a-task-is-slower-than-executing-the-task",
      children: "缓存任务比执行任务慢 "
    }), "\n", _jsx(_components.p, {
      children: "¥Caching a task is slower than executing the task"
    }), "\n", _jsx(_components.p, {
      children: "也有可能出现缓存比不缓存更慢的情况。这种情况很少见，但以下是一些示例："
    }), "\n", _jsx(_components.p, {
      children: "¥It's possible to create scenarios where caching ends up being slower than not caching. These cases are rare, but a few examples include:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["执行速度极快的任务：如果任务的执行速度快于与 ", _jsx(_components.a, {
            href: "/docs/core-concepts/remote-caching",
            children: "远程缓存"
          }), " 的网络往返速度，则应考虑不缓存该任务。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Tasks that execute extremely fast"
          }), ": If a task executes faster than a network round-trip to the ", _jsx(_components.a, {
            href: "/docs/core-concepts/remote-caching",
            children: "Remote Cache"
          }), ", you should consider not caching the task."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "输出资源巨大的任务：有可能创建一个非常大的工件，以至于上传或下载它的时间超过了重新生成它的时间，例如一个完整的 Docker 容器。在这些情况下，你应该考虑不缓存该任务。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Tasks whose output assets are enormous"
          }), ": It's possible to create an artifact that is so big that the time to upload or download it exceeds the time to regenerate it, like a complete Docker Container. In these cases, you should consider not caching the task."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "具有自身缓存的脚本：某些任务有自己的内部缓存行为。在这些情况下，为了使 Turborepo 的缓存和应用缓存协同工作，配置很快就会变得复杂。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Scripts that have their own caching"
          }), ": Some tasks have their own internal caching behavior. In these cases, configuration can quickly become complicated to make Turborepo's cache and the application cache work together."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "虽然这些情况很少见，但请务必测试项目的行为，以确定在特定位置禁用缓存是否能带来性能提升。"
    }), "\n", _jsx(_components.p, {
      children: "¥While these situations are rare, be sure to test the behavior of your projects to determine if disabling caching in specific places provides a performance benefit."
    }), "\n", _jsx(_components.h2, {
      id: "后续步骤-next-steps",
      children: "后续步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Next steps"
    }), "\n", _jsx(_components.p, {
      children: "现在你已经了解了 Turborepo 的缓存如何使你的存储库更快，让我们来看看如何在 Turborepo 中开发应用和库。"
    }), "\n", _jsx(_components.p, {
      children: "¥Now that you've seen how Turborepo's caching makes your repository faster, let's take a look at how to develop applications and libraries in your Turborepo."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
